<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <div class="d-flex justify-content-center align-items-center"><h4 class="card-title mr-2">Ví USDT</h4>
              <span class="mt-1 text-secondary">Giúp bạn nạp rút USDT để sử dụng hệ thống</span>
            </div>
          </template>
          <template v-slot:body>
            <!-- <b-button v-b-modal.modal-1 variant="primary" size="md" class="my-3">
              <i class="las la-donate"/>
              NẠP
            </b-button> -->
            <b-button v-b-modal.modal-2 variant="primary" size="md" class="my-3 ml-2 withdraw-style">
              <i class="las la-hand-holding-usd"/>
              RÚT
            </b-button>
            <h5> Lịch sử nạp rút </h5>
            <div class="table-responsive">
              <b-table
                id="user-list-table"
                ref="tnxList"
                :items="tnxList"
                :fields="fields"
                :striped="false"
                :outlined="true"
                :small="true"
                :hover="true"
                :busy.sync="isBusy"
                :current-page="currentPage"
                :per-page="localItemsPerPage"
                :primary-key="'id'"
                :no-local-sorting="true"
                @sort-changed="sortChange"
                :tbody-tr-class="rowClass"
                class="table-striped table-bordered mt-1"
                role="grid"
                aria-describedby="user-list-page-info"
                show-empty
              >
                <template v-slot:cell(type)="data">
                  <b-badge pill :variant="'primary'" v-show="data.item.rawType === 'deposit'">
                    <span>{{ data.item.type }}</span>
                  </b-badge>
                  <b-badge pill :variant="'warning'" v-show="data.item.rawType === 'withdraw'" class="withdraw-style">
                    <span>{{ data.item.type }}</span>
                  </b-badge>
                </template>
                <template v-slot:cell(status)="data">
                  <b-badge pill :variant="'secondary'" v-show="data.item.rawStatus === 0">
                    <span>{{ data.item.status }}</span>
                  </b-badge>
                  <b-badge pill :variant="'primary'" v-show="data.item.rawStatus === 1">
                    <span>{{ data.item.status }}</span>
                  </b-badge>
                  <b-badge pill :variant="'danger'" v-show="data.item.rawStatus === -1">
                    <span>{{ data.item.status }}</span>
                  </b-badge>
                  <b-badge pill :variant="'danger'" v-show="data.item.rawStatus === -2">
                    <span>{{ data.item.status }}</span>
                  </b-badge>
                </template>
                <template v-slot:cell(amount)="data">
                  <span v-if="data.item.rawType === 'deposit'" :style="{color:'#3C763D'}">+{{
                      applyNumberFormat(data.item.amount, 'en')
                                                                                          }}</span>
                  <span v-if="data.item.rawType === 'withdraw'" :style="{color:'#A94442'}">-{{
                      applyNumberFormat(data.item.amount, 'en')
                                                                                           }}</span>
                </template>
                <template v-slot:cell(created_at)="data">
                  <div>
                    <span>{{ data.item.created_at | formatDatetimeVN }}</span>
                  </div>
                </template>
                <template v-slot:cell(action)="data">
                  <div>
                    <i v-if="data.item.rawType === 'withdraw' && data.item.rawStatus === 0" @click="removeWithdrawTransaction(data.item.id)" class="las la-trash-alt text-red"></i>
                  </div>
                </template>
                <template #empty="scope">
                  <p class="text-center">Chưa có dữ liệu</p>
                </template>
                <template #emptyfiltered="scope">
                  <p class="text-center">Không tìm thấy dữ liệu</p>
                </template>
              </b-table>
              <b-pagination
                @change="pageChange"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="center"
                size="md"
                class="mt-3"
              ></b-pagination>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <deposit-modal modal-id="modal-1"/>
    <withdraw-modal modal-id="modal-2"/>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit'
import api from '@/store/api'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import DepositModal from '@/components/application/usdt_transaction/DepositModal'
import WithdrawModal from '@/components/application/usdt_transaction/WithdrawModal'
import { applyNumberStyle, formatNumberByLocale } from '@/utils'

export default {
  name: 'DepositWithdraw',
  components: { WithdrawModal, DepositModal },
  async mounted () {
    findash.index()
    this.tnxList = await this.loadPage(this.currentPage, this.perPage)
  },
  data () {
    return {
      currentPage: 1,
      perPage: 50, //
      localItemsPerPage: 0, // if you want use SSR
      isBusy: false,
      ssrLength: 0,
      fields: [
        {
          key: 'type',
          label: 'Loại',
          class: 'text-center',
          thStyle: { width: '10%' }
        },
        {
          key: 'amount',
          label: 'Số lượng USDT',
          class: 'text-right',
          thStyle: { width: '15%' }
        },
        {
          key: 'content',
          label: 'Nội dung'
        },
        {
          key: 'status',
          label: 'Trạng thái',
          class: 'text-center',
          thStyle: { width: '10%' }
        },
        {
          key: 'created_at',
          label: 'Thời gian',
          class: 'text-center',
          thStyle: { width: '25%' }
        },
        {
          key: 'action',
          label: 'Thao tác',
          class: 'text-center',
          thStyle: { width: '10%' }
        }
      ],
      tnxList: [],
      customerList: null, // this could be load on state of vuex (using mapState and mapAction functions)
      modal: {
        customer: null,
        payment_cycle: null,
        money_type: null,
        payment_type: null,
        payment_amount: 0,
        note: ''
      },
      modal_default_params: {
        customer: null,
        payment_cycle: null,
        money_type: null,
        payment_type: null,
        payment_amount: 0,
        note: ''
      }
    }
  },
  computed: {
    totalRows () {
      return this.ssrLength
    },
    ...mapGetters({
      'customerOptions': 'Customer/listOptionsState',
      'rangeReportOptions': 'Report/rangeReportListOptionsState',
      'serverError': 'Setting/serverErrorsState',
      'serverRequesting': 'Setting/serverRequestingState'
    })
  },
  methods: {
    parseResponse (res) {
      let data = null

      data = _.map(res, (r) => {
        let statusLabel = ''
        let typeLabel = ''
        let rawStatus = parseInt(r[3])
        let rawType = r[0]
        switch (r[0]) {
          case 'deposit':
            typeLabel = 'Nạp'
            break
          case 'withdraw':
            typeLabel = 'Rút'
            break
        }

        switch (rawStatus) {
          case 0:
            statusLabel = 'Chờ xử lý'
            break
          case 1:
            statusLabel = 'Đang xử lý'
            break
          case 2:
            statusLabel = 'Hoàn tất'
            break
          case -1:
            statusLabel = 'Từ chối'
            break
          case -2:
            statusLabel = 'Lỗi'
            break
        }
        return {
          rawType: rawType,
          type: typeLabel,
          amount: r[1],
          content: r[2],
          rawStatus: rawStatus,
          status: statusLabel,
          created_at: r[4],
          id: r[5]
        }
      })

      return data
    },
    loadPage (currentPage, perPage) {
      this.isBusy = true
      let promise = api.transaction.datatables_usdt_list(Object.assign({
        start: (currentPage * perPage) - perPage,
        length: perPage,
        draw: currentPage
      }))

      return promise.then((response) => {
        const items = this.parseResponse(response.data)
        this.ssrLength = parseInt(response.recordsTotal)
        this.isBusy = false
        return (items)
      }).catch(() => {
        this.isBusy = false
        return []
      })
    },
    async pageChange (page) {
      this.tnxList = await this.loadPage(page, this.perPage)
    },
    async sortChange (ctx) {
      if (ctx.sortBy === 'created_at' && ctx.sortDesc) {
        this.datatableSort['order[0][dir]'] = 'desc'
      } else {
        this.datatableSort['order[0][dir]'] = 'asc'
      }

      this.tnxList = await this.loadPage(this.currentPage, this.perPage)
    },
    rowClass (item, type) {
      if (!item || type !== 'row') return
      if (item.status === '-1') return 'row-line-though'
    },
    confirm () {
      try {
        let params = {
          'member_id': this.modal.customer.id,
          'report_id': this.modal.payment_cycle.id,
          'currency_id': this.modal.money_type,
          'type': this.modal.payment_type, // enum : payment/other
          'amount': this.modal.payment_amount,
          'note': this.modal.note // optional
        }

        api.transaction.create(params).then(async () => {
          this.$swal({
            icon: 'success',
            title: 'Thêm thành công'
          })
          this.$bvModal.hide('modal-1')

          // reset form
          this.modal = this.modal_default_params
          // load list
          this.tnxList = await this.loadPage(this.currentPage, this.perPage)
        }).catch(() => {
          this.$swal({
            icon: 'error',
            title: 'Lỗi...',
            text: this.serverError
          })
        })
      } catch {

      }
    },
    removeWithdrawTransaction (id) {
      this.$swal({
        title: 'Nhập mã OTP để hủy',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Hủy',
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.isConfirmed) {
          api.transaction.cancel_withdraw_usdt({
            id: id,
            otp: result.value
          }).then(async () => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })
            // load list
            this.tnxList = await this.loadPage(this.currentPage, this.perPage)
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            })
          })
        }
      })
    },
    confirmDelete (id) {
      this.$swal({
        title: 'Giao dịch',
        text: 'Bạn chắc chắn xóa giao dịch này ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Xóa',
        denyButtonText: `Hủy`
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          api.transaction.delete(id).then(async () => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })

            // load list
            this.tnxList = await this.loadPage(this.currentPage, this.perPage)
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            })
          })
        } else if (result.isDenied) {

        }
      }).catch(() => {
      })
    },
    applyNumberStyle (number) {
      return applyNumberStyle(number)
    },
    applyNumberFormat (number, locale) {
      return formatNumberByLocale(number, locale)
    }
  }
}
</script>
